import React, { useImperativeHandle, useEffect, useState, useMemo } from 'react';
import { message, Select } from 'antd';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import useGroups from '../../gql/hooks/useGroups';
import './styles.less';

const FormProducts = ( { form, modifiedCallback, ref } ) => {
    const [ productIds, setProductIds ] = useState( [] );
    const [ sync ] = useSyncObjectRelationships();
    const { groups, groupsLoading, groupsError } = useGroups();
    
    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'productIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getProductsSyncValues( form );
            
            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateProductsValues( form, syncData.relatedResourceIds );
                    reset();
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = () => {
        form.setFieldsValue( { productIdsAreModified: false } ); 
        form.setFieldsValue( { productIdsModified: [] } ); 
        setProductIds( form.getFieldValue( 'productIds' ) );
        modifiedCallback( false ); 
    };

    const listData = useMemo( () => { 
        return groups.filter( i => {
            return i.attributes.find( a => a.name === 'product' );
        } );
    }, [ groups ] );

    useEffect( () => listData && setProductIds( form.getFieldValue( 'productIds' ) ), 
        [ listData, setProductIds ] );

    const handleChangeIds = ( values ) => {
        setProductIds( values ); 

        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'productIds' ) ) ) {
            form.setFieldsValue( { productIdsAreModified: true } ); 
            form.setFieldsValue( { productIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { productIdsAreModified: false } ); 
            form.setFieldsValue( { productIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-products">
            { !groupsLoading && !groupsError &&
                <>
                    <h4 style={ { marginBottom: '8px' } }>Products</h4>
                    <Select
                        mode="multiple"
                        value={ productIds }
                        placeholder="Select" 
                        onChange={ handleChangeIds }
                        filterOption={ ( input, option ) => 
                            ( option?.children ? 
                                option.children[ 0 ].type ? '' : option.children[ 0 ]
                                : '' ).toLowerCase().includes( input.toLowerCase() )
                        }
                    >
                        {
                            listData.map( i => {
                                return ( 
                                    <Select.Option 
                                        key={ i.id } 
                                        value={ i.id }  
                                    >
                                        { i.name || <span className='italic'>No Name</span> }
                                    </Select.Option>
                                );
                            } )
                        }
                    </Select>
                </>
            }
        </div>
    );
};

export default FormProducts;
